import Box from "@mui/material/Box";
import Skeleton from "../../../../../CommonComponents/Skeleton";

export const SOAMockTestsSkeleton = () => {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px",flex:1, }}>
      <Skeleton
        sx={{ width: "110px", height: "30px", marginBottom: "5px" }}
        animation="wave"
      />
      <Box
        sx={{
          height: "250px",
          padding: "14px 24px",
          borderRadius: "8px",
          bgcolor: "white",
          flex: 1,
        }}
      >
        <Skeleton
          sx={{ width: "142px", height: "24px", marginBottom: "7px" }}
          animation="wave"
        />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            gap: "12px",
          }}
        >
          {Array.from({ length: 2 }).map((_, i) => (
            <Skeleton
              key={i}
              animation="wave"
              sx={{ /* width: "554px", */ height: "48px", borderRadius: "8px" }}
            />
          ))}
          <Skeleton
            animation="wave"
            sx={{ /* width: "554px", */ height: "48px", borderRadius: "8px" }}
          />
        </Box>
      </Box>
    </div>
  );
};
